/* eslint-disable react/prop-types */
import React from 'react';
import MuiAppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { Divider } from '@mui/material';
import { useCommonInits } from 'hooks/useCommonInits';

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
    width: 'calc(100% - 68px)',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    background: 'transparent',
    boxShadow: 'none',
    border: 0,
    ...(open && {
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
}));

export default function ButtonAppBar({ children, hideDefault, drawerToggle }) {
    const { dispatch, } = useCommonInits();
    const {  dashbord } = useSelector(
        state => state.dashboard,
    );


    return (
        <AppBar
            position="relative"
            open
            sx={{
                width: '100%',
            }}
        >
           
            <Divider />
        </AppBar>
    );
}

const smBreakpoint = '@media (max-width: 576px)';


